// eslint-disable-next-line import/no-cycle
import { PluginSetup as Startup } from "./startup/index.js";
import Imagine from "./imagine/PluginSetup.js";
import { PluginSetup as Routes } from "./routes/index.js";
import Attributes from "./attributes/PluginSetup.js";
import { PluginSetup as Tracking } from "./tracking/index.js";
import Screens from "./screens/PluginSetup.js";
import DataViewers from "./dataViewers/PluginSetup.js";
import Views from "./views/PluginSetup.js";
import Groupings from "./groupings/PluginSetup.js";
import Filters from "./filters/PluginSetup.js";
import History from "./history/PluginSetup.js";
export default {
  install: molten => {
    Startup.install(molten);
    Tracking.install(molten);
    Imagine.install(molten);
    DataViewers.install(molten);
    Screens.install(molten);
    Routes.install(molten);
    Views.install(molten);
    Attributes.install(molten);
    Groupings.install(molten);
    Filters.install(molten);
    History.install(molten);
  }
};